import { render } from "./WCItemGroupSelector.vue?vue&type=template&id=20ba584e&scoped=true"
import script from "./WCItemGroupSelector.vue?vue&type=script&lang=js"
export * from "./WCItemGroupSelector.vue?vue&type=script&lang=js"

import "./WCItemGroupSelector.vue?vue&type=style&index=0&id=20ba584e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ba584e"]])

export default __exports__